import styled from 'styled-components/macro';

import * as colors from '../common/colorConstants';
import * as breakpoints from '../common/mediaQueries';

export const BottomButtonsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  bottom: 0;
  transition: 0.3s ease;
`;

export const Label = styled.div`
  user-select: none;
  margin-top: 7px;
  text-transform: capitalize;
  color: ${colors.lightWhite};
  margin-bottom: 11px;

  font-size: 9px;
  line-height: 11px;

  @media (min-height: ${breakpoints.mediumHeight}) {
    font-size: 10px;
    line-height: 12px;
    margin-bottom: 14px;
  }

  @media (min-height: ${breakpoints.normalHeight}) {
    font-size: 11px;
    line-height: 13px;
  }
`;

export const ToggleSwitch = styled.input`
  width: 20px;
  min-height: 9px;
  border-radius: 4.5px;
  appearance: none;
  background: ${colors.orange};
  position: relative;
  outline: none !important;
  transition: background 0.15s linear;
  cursor: pointer;

  :before {
    content: '';
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: ${colors.lightGray1};
    position: absolute;
    left: 0;
    bottom: 50%;
    transform: translateY(50%);
    transition: transform 0.15s linear;
  }

  :checked {
    background: ${colors.simplrBlue};
    :before {
      transform: translate(100%, 50%);
    }
  }
`;

export const HeaderBox = styled.div`
  display: flex;
  flex-wrap: nowrap;
  border: none;
  border-right: 1px solid ${colors.lightGray3};
  position: absolute;
  top: 0;
  left: 0%;
  z-index: 1000;
  flex-direction: column;
  height: 100vh;
  background-color: ${colors.darkGray2};
  font-family: 'Roboto Condensed', sans-serif;
  letter-spacing: -0.3px;
  align-items: center;
  width: 60px;
  padding-bottom: 130px; // This must be equal to the height of <BottomButtonsWrapper>.
`;

export const DarkModeSwitch = styled.input`
  width: 32px;
  min-height: 16px;
  border-radius: 8px;
  appearance: none;
  background: ${colors.darkGray4};
  position: relative;
  outline: none !important;
  transition: background 0.15s linear;
  cursor: pointer;
  margin-top: 8px;

  :before {
    content: '';
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: ${colors.lightGray1};
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 24 24' fill='none' stroke='%23495671' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='12' cy='12' r='5'/%3E%3Cline x1='12' y1='1' x2='12' y2='3'/%3E%3Cline x1='12' y1='21' x2='12' y2='23'/%3E%3Cline x1='4.22' y1='4.22' x2='5.64' y2='5.64'/%3E%3Cline x1='18.36' y1='18.36' x2='19.78' y2='19.78'/%3E%3Cline x1='1' y1='12' x2='3' y2='12'/%3E%3Cline x1='21' y1='12' x2='23' y2='12'/%3E%3Cline x1='4.22' y1='19.78' x2='5.64' y2='18.36'/%3E%3Cline x1='18.36' y1='5.64' x2='19.78' y2='4.22'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    position: absolute;
    left: 0;
    bottom: 50%;
    transform: translateY(50%);
    transition: transform 0.15s linear;
  }

  :checked {
    background: ${colors.simplrBlue};
    :before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 24 24' fill='none' stroke='%23FFFFFF' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z'/%3E%3C/svg%3E");
      transform: translate(78%, 50%);
    }
  }
`;

export const RestartSectionWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const TooltipOverlay = styled.div`
  max-width: 180px;
  display: block;
  font-family: Roboto, sans-serif;
  line-height: 15px;
  color: ${colors.lightBlack};
  user-select: none;
  background-color: ${colors.baseBackground};
  padding: 10px;
  position: relative;
`;
